import * as Cesium from 'cesium';

export interface NightLightingController {
  setEnabled: (enabled: boolean) => void;
  setTime: (date: Date) => void;
}

function isNight(date: Date): boolean {
  const hour = date.getHours() + date.getMinutes() / 60;
  return hour >= 18 || hour < 6;
}

/**
 * 夜間の見え方を整える独立した演出レイヤー。
 * 建物形状を改変せず、夜色・月明かり・弱いブルームを追加する。
 * LOD1の窓明かりは buildingFacadeShader.ts が担当する。
 */
export function createNightLighting(viewer: Cesium.Viewer): NightLightingController {
  const { scene } = viewer;
  const bloom = scene.postProcessStages.bloom;
  bloom.enabled = false;

  const sky = scene.skyAtmosphere;
  const originalSkyBrightness = sky?.brightnessShift ?? 0;
  const originalSkySaturation = sky?.saturationShift ?? 0;
  const originalDiffuseMultiplier = scene.globe.lambertDiffuseMultiplier;
  const originalLight = scene.light;
  let enabled = true;
  let date = new Date();

  const render = (): void => {
    const active = enabled && isNight(date);
    bloom.enabled = active;

    if (sky) {
      sky.brightnessShift = active ? -0.35 : originalSkyBrightness;
      sky.saturationShift = active ? -0.12 : originalSkySaturation;
    }
    scene.globe.lambertDiffuseMultiplier = active
      ? 0.45
      : originalDiffuseMultiplier;

    if (active) {
      scene.light = new Cesium.SunLight({
        color: Cesium.Color.fromBytes(135, 155, 205),
        intensity: 0.35,
      });
    } else {
      scene.light = originalLight;
    }
    scene.requestRender();
  };

  render();

  return {
    setEnabled(nextEnabled) {
      enabled = nextEnabled;
      render();
    },
    setTime(nextDate) {
      date = nextDate;
      render();
    },
  };
}
